import React from "react";
import { TimeStamp } from "../../../arrow/components/Atoms/TimeStamp";
import { HeroImage } from "../../../arrow/components/Atoms/HeroImage";
import { object, array, bool } from "prop-types";
import { Link } from "@quintype/components";
import "./image-type-2.m.css";

const ImageType2 = ({ story, showSection = false, widths = [250, 375] }) => {
  const storyObj = story.story ? story.story : story;
  const accessType = "subscription"; //storyObj.access;
  const imgS3keys = storyObj["hero-image-s3-key"];
  return (
    <div styleName="wrapper" className="type-2">
      <Link href={`/${storyObj.slug}`}>
        <div styleName="type-2" className="type-2-card">
          {showSection && <h1>{storyObj.sections[0].name}</h1>}
          {imgS3keys !== null && <HeroImage story={storyObj} defaultWidth={183} widths={widths} />}
        </div>
      </Link>
      <div className="main-headline" styleName="story-content">
        <div styleName="wrapper-inside" className="wrapper-inside">
          <Link href={`/${storyObj.slug}`}>
            <h2 styleName="headline-link">{storyObj.headline}</h2>
          </Link>

          <div styleName="section-time-wrapper">
            <TimeStamp story={storyObj} />
            {(accessType === "login" || accessType === "subscription") && <i class="ri-star-fill"></i>}
          </div>
        </div>
      </div>
    </div>
  );
};
ImageType2.propTypes = {
  story: object,
  widths: array,
  showSection: bool,
};
export default React.memo(ImageType2);
